<template>

    <div id="agility_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="container">

            <div class="agility_scores_container">

                <div id="chart" class="container" v-if="refScoresData && evalScoresData">

                    <div class="chart_labels_container">
                        <div class="evalution_item_name">
                            <div class="eval_color candidate_item" ></div>
                            <div class="eval_username">{{currentEval.candidate_username}}</div>
                        </div>
                        <div class="evalution_item_name">
                            <div class="eval_color" ></div>
                            <div class="eval_username">{{ $t('modules.evaluations.edit.chartRefLegend') }}</div>
                        </div>
                    </div>
                    <RadarChart :chartData="chartDatas" />
                </div>

            </div>

        </div>
    </div>

</template>

<script>
import RadarChart from './radarChart'

export default {
    name: 'ChartTab',
    components: {
        RadarChart
    },
    data(){
        return {}
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        currentRef(){
            return this.currentEval.saven_test.sight_ref
        },
        refScoresData(){
            if (this.currentRef){
                return [
                    this.currentRef.sight2_scores.f1,
                    this.currentRef.sight2_scores.f2,
                    this.currentRef.sight2_scores.f3,
                    this.currentRef.sight2_scores.f4,
                    this.currentRef.sight2_scores.c1,
                    this.currentRef.sight2_scores.c2,
                    this.currentRef.sight2_scores.c3,
                    this.currentRef.sight2_scores.c4,
                    this.currentRef.sight2_scores.t1,
                    this.currentRef.sight2_scores.t2,
                    this.currentRef.sight2_scores.t3,
                    this.currentRef.sight2_scores.t4,
                    this.currentRef.sight2_scores.t5,
                    this.currentRef.sight2_scores.t6,
                    this.currentRef.sight2_scores.t,
                    this.currentRef.sight2_scores.e,
                    this.currentRef.sight2_scores.s
                ]
            }
        },
        evalScoresData(){
            if (this.currentEval){
                return [
                    this.currentEval.saven_test.game_rules_scores.f1,
                    this.currentEval.saven_test.game_rules_scores.f2,
                    this.currentEval.saven_test.game_rules_scores.f3,
                    this.currentEval.saven_test.game_rules_scores.f4,
                    this.currentEval.saven_test.transversal_skills_scores.c1,
                    this.currentEval.saven_test.transversal_skills_scores.c2,
                    this.currentEval.saven_test.transversal_skills_scores.c3,
                    this.currentEval.saven_test.transversal_skills_scores.c4,
                    this.currentEval.saven_test.behavioral_skills_scores.t1,
                    this.currentEval.saven_test.behavioral_skills_scores.t2,
                    this.currentEval.saven_test.behavioral_skills_scores.t3,
                    this.currentEval.saven_test.behavioral_skills_scores.t4,
                    this.currentEval.saven_test.behavioral_skills_scores.t5,
                    this.currentEval.saven_test.behavioral_skills_scores.t6,
                    this.currentEval.saven_test.resolution_strategy_scores.t,
                    this.currentEval.saven_test.resolution_strategy_scores.e,
                    this.currentEval.saven_test.resolution_strategy_scores.s
                ]
            }
        },
        chartDatas(){
            return [
                {
                    label: 'referentiel',
                    data: this.refScoresData,
                    lineTension: 0.1,
                    borderColor: "rgba(150, 150, 150, 0) ",
                    backgroundColor: "rgba(150, 150, 150, 0.35) ",
                    pointRadius: 0
                },
                {
                    label: 'autre',
                    data: this.evalScoresData,
                    fill: false,
                    lineTension: 0.1,
                    borderColor: '#00ddc0',
                    pointRadius: 0
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
#chart{
    width: 100%;
    max-width: 1100px;
    .chart_labels_container{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .evalution_item_name{
            display: flex;
            align-items: center;
            margin: 24px 8px 0;
            .eval_color{
                height: 16px;
                width: 32px;
                border: 1px solid rgba(128, 128, 128, 0.18);
                margin-right: 8px;
                background: rgba(150, 150, 150, 0.35);
                &.candidate_item{
                    background: $info;
                }
            }
            &.active{
                .eval_color{
                    border-width: 8px;
                }
            }
        }
    }
}


</style>